import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

/**
 * Handles the OAuth return from Emergent Google Auth.
 * Receives a fragment like #session_id=XXX, exchanges it for a JWT,
 * and redirects to /conta.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
    const nav = useNavigate();
    const { loginWithGoogleSession } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            toast.error("Sessão Google em falta");
            nav("/conta/login", { replace: true });
            return;
        }
        const sid = decodeURIComponent(m[1]);

        loginWithGoogleSession(sid)
            .then(() => {
                // limpa fragment
                window.history.replaceState({}, document.title, "/conta");
                toast.success("Sessão iniciada com Google");
                nav("/conta", { replace: true });
            })
            .catch((err) => {
                toast.error(err?.response?.data?.detail || "Erro a autenticar com Google");
                nav("/conta/login", { replace: true });
            });
    }, [loginWithGoogleSession, nav]);

    return (
        <div className="min-h-screen flex items-center justify-center font-mono" data-testid="auth-callback-page">
            <div className="text-center">
                <Loader2 className="animate-spin mx-auto mb-3" size={32} />
                <div className="text-sm text-ink/70">A confirmar sessão Google…</div>
            </div>
        </div>
    );
}
